import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './FlussoPersonalizzazionePosizione.module.sass'
import { PosizionePersonalizzazioneType, RootStateType, UserType } from '@utils/types'
import { useSelector } from 'react-redux'
import { PosizionePersonalizzazioneOrdineStatus, StatoOrdine } from '@components/atoms'
import { ChevronDown } from '@components/icons'
import useTrans from '@hooks/useTrans'


interface Props {
  posizione: PosizionePersonalizzazioneType
  posizioniOpen: number[]
  setPosizioniOpen: React.Dispatch<React.SetStateAction<number[]>>
  status?: '' | 'completed' | 'unsaved'
  userType: UserType
  children?: React.ReactNode
  className?: string
}

const FlussoPersonalizzazionePosizione = (props: Props) => {

  const { 
    posizione,
    posizioniOpen,
    setPosizioniOpen,
    status,
    userType,
    children,
    className = '',
  } = props

  const t = useTrans()
  const { utente } = useSelector((state: RootStateType) => state.utente)
  const details = [
    { label: t("Posizione:"), value: posizione?.posizione?.nome || '-' },
  ]
  
  return (
    <div className={cn(styles.root, posizioniOpen.includes(posizione.id) ? styles['root--open'] : '', className)} id={`posizione_${posizione.id}`}>
      <button type="button" className={styles.trigger} onClick={() => setPosizioniOpen(prev => prev.includes(posizione.id) ? prev.filter(p => p !== posizione.id) : prev.concat([posizione.id]))}>
        <div className={styles.triggerTitle}>
          <h3 className={styles.details}>
            {details.map(d => (
              <span className={styles.detail} key={d.label}>
                <span className={styles.detailLabel}>{d.label}{' '}</span>
                <span className={styles.detailValue}>{d.value}</span>
              </span>
            ))}
          </h3>
          <StatoOrdine level="posizione" userType={userType} stato={posizione.statoPosizionePersonalizzazione} />
        </div>
        <PosizionePersonalizzazioneOrdineStatus status={status} className={styles.triggerStatus} />
        <ChevronDown className={styles.triggerArrow} />
      </button>

      <div className={styles.body}>
        {children}
      </div>
    </div>
  )
}

export default FlussoPersonalizzazionePosizione
